export var BusinessDisplayMode;
(function (BusinessDisplayMode) {
    BusinessDisplayMode["Categories"] = "Categories";
    BusinessDisplayMode["List"] = "List";
})(BusinessDisplayMode || (BusinessDisplayMode = {}));
